// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3ZW9o","paramInput":"JobSimulator_paramInput__2-W3t","input":"JobSimulator_input__2GEFk"};